export const API_URI = "http://aqar.tecnovaters.com/api/v1";
export const IMAGE_URI = "http://aqar.tecnovaters.com/media";



// WEBPACK FOOTER //
// ./src/utils/config.js